export default "__VITE_ASSET__CdfGFKRz__"